import {Component, OnInit, ViewEncapsulation} from '@angular/core';

@Component({
  selector: 'app-programming',
  templateUrl: './programming.component.html',
  styleUrls: ['./programming.component.scss'],
  encapsulation: ViewEncapsulation.Emulated
})
export class ProgrammingComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
